/* ==========================================================================
   ELORE — Product Page Script
   ========================================================================== */

(function () {
  "use strict";

  function initProductPage(root) {
    if (!root) return function () {};

    /* ==========================================================
       STICKY ADD TO CART BAR
       ========================================================== */

    var stickyBar = root.querySelector("#sticky-bar");
    var anchor = root.querySelector("#product-info-anchor");

    function handleStickyBar() {
      if (!stickyBar || !anchor) return;

      var anchorRect = anchor.getBoundingClientRect();

      if (anchorRect.bottom < 0) {
        stickyBar.classList.remove("translate-y-full");
      } else {
        stickyBar.classList.add("translate-y-full");
      }
    }

    window.addEventListener("scroll", handleStickyBar, {
      passive: true
    });

    handleStickyBar();


    /* ==========================================================
       SCROLL REVEAL
       ========================================================== */

    var observer = null;

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("active");
            }
          });
        },
        {
          threshold: 0.1
        }
      );

      root.querySelectorAll("section").forEach(function (section) {
        section.classList.add("scroll-reveal");
        observer.observe(section);
      });
    }


    /* ==========================================================
       PRODUCT GALLERY
       ========================================================== */

    var carousel = root.querySelector("#product-main-carousel");
    var slides = root.querySelectorAll("[data-product-slide]");
    var thumbnails = root.querySelectorAll("[data-product-thumbnail]");

    var galleryScrollTimer = null;

    function setActiveThumbnail(index) {
      thumbnails.forEach(function (thumbnail, i) {
        if (i === index) {
          thumbnail.classList.add(
            "border-primary",
            "opacity-100",
            "scale-105",
            "shadow-sm"
          );

          thumbnail.classList.remove(
            "border-transparent",
            "opacity-55"
          );
        } else {
          thumbnail.classList.remove(
            "border-primary",
            "opacity-100",
            "scale-105",
            "shadow-sm"
          );

          thumbnail.classList.add(
            "border-transparent",
            "opacity-55"
          );
        }
      });

      var activeThumbnail = thumbnails[index];

      if (activeThumbnail) {
        activeThumbnail.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    }

    function updateGalleryHeight(index) {
      if (!carousel) return;

      var slide = slides[index];

      if (!slide) return;

      var image = slide.querySelector("img");

      if (!image) return;

      function setHeight() {
        if (image.offsetHeight > 0) {
          carousel.style.height = image.offsetHeight + "px";
        }
      }

      if (image.complete) {
        setHeight();
      } else {
        image.addEventListener("load", setHeight, {
          once: true
        });
      }
    }

    function goToImage(index) {
      if (!carousel || !slides.length) return;

      index = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      var slide = slides[index];

      if (!slide) return;

      carousel.scrollTo({
        left: carousel.clientWidth * index,
        behavior: "smooth"
      });

      setActiveThumbnail(index);
      updateGalleryHeight(index);
    }

    if (carousel && slides.length) {

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener("click", function () {
          var index = Number(
            thumbnail.getAttribute("data-index")
          );

          goToImage(index);
        });
      });

      carousel.addEventListener(
        "scroll",
        function () {
          clearTimeout(galleryScrollTimer);

          galleryScrollTimer = setTimeout(function () {
            if (!carousel.clientWidth) return;

            var index = Math.round(
              carousel.scrollLeft / carousel.clientWidth
            );

            index = Math.max(
              0,
              Math.min(index, slides.length - 1)
            );

            setActiveThumbnail(index);
            updateGalleryHeight(index);
          }, 80);
        },
        {
          passive: true
        }
      );

      var initialIndex = 0;

      setActiveThumbnail(initialIndex);
      updateGalleryHeight(initialIndex);

      window.addEventListener("resize", function () {
        if (!carousel.clientWidth) return;

        var index = Math.round(
          carousel.scrollLeft / carousel.clientWidth
        );

        updateGalleryHeight(index);
      });
    }


    /* ==========================================================
       PRODUCT SIZE SELECTION
       ========================================================== */

    /* ==========================================================
   PRODUCT SIZE + VARIANT SELECTION
   ========================================================== */

var sizeOptions = root.querySelectorAll(
  "#product-size-options .size-option"
);

var stickyVariantInput = root.querySelector(
  "#sticky-variant-id"
);

var buyNowVariantInput = root.querySelector(
  "#buy-now-variant"
);

var buyNowButton = root.querySelector(
  '[id^="buy-now-button-"]'
);

if (buyNowButton) {
  buyNowButton.disabled = !(
    buyNowVariantInput &&
    buyNowVariantInput.value
  );
}


/* ==========================================================
   ELORE SIZE MESSAGE
   ========================================================== */

function showSizeMessage(message) {

  var existingMessage = document.getElementById(
    "elore-size-message"
  );

  if (existingMessage) {
    existingMessage.remove();
  }

  var messageBox = document.createElement("div");

  messageBox.id = "elore-size-message";

  messageBox.textContent =
    message || "Please select a size.";

  messageBox.style.position = "fixed";
  messageBox.style.left = "50%";
  messageBox.style.bottom = "32px";
  messageBox.style.transform =
    "translateX(-50%) translateY(20px)";
  messageBox.style.zIndex = "99999";
  messageBox.style.padding =
    "13px 22px";
  messageBox.style.borderRadius =
    "999px";
  messageBox.style.background =
    "#fdf9f0";
  messageBox.style.color =
    "#302b25";
  messageBox.style.border =
    "1px solid rgba(48,43,37,.15)";
  messageBox.style.boxShadow =
    "0 10px 30px rgba(48,43,37,.12)";
  messageBox.style.fontFamily =
    "Montserrat, sans-serif";
  messageBox.style.fontSize =
    "11px";
  messageBox.style.fontWeight =
    "500";
  messageBox.style.letterSpacing =
    ".08em";
  messageBox.style.textTransform =
    "uppercase";
  messageBox.style.opacity =
    "0";
  messageBox.style.transition =
    "opacity .25s ease, transform .25s ease";

  document.body.appendChild(messageBox);

  requestAnimationFrame(function () {
    messageBox.style.opacity = "1";
    messageBox.style.transform =
      "translateX(-50%) translateY(0)";
  });

  setTimeout(function () {

    messageBox.style.opacity = "0";

    messageBox.style.transform =
      "translateX(-50%) translateY(20px)";

    setTimeout(function () {
      messageBox.remove();
    }, 250);

  }, 2500);
}


/* ==========================================================
   SIZE SELECTION
   ========================================================== */

sizeOptions.forEach(function (sizeButton) {

  sizeButton.addEventListener(
    "click",
    function () {

      if (sizeButton.disabled) {
        return;
      }

      var variantId =
        sizeButton.getAttribute(
          "data-variant-id"
        );

      if (!variantId) {
        showSizeMessage(
          "This size is currently unavailable."
        );
        return;
      }


      /* Reset all sizes */

      sizeOptions.forEach(function (button) {

        button.classList.remove(
          "border-primary",
          "bg-primary",
          "text-surface"
        );

        button.classList.add(
          "border-outline"
        );

      });


      /* Highlight selected size */

      sizeButton.classList.remove(
        "border-outline"
      );

      sizeButton.classList.add(
        "border-primary",
        "bg-primary",
        "text-surface"
      );


      /* Set the actual Shopify variant */

      if (stickyVariantInput) {
        stickyVariantInput.value =
          variantId;
      }

      if (buyNowVariantInput) {
        buyNowVariantInput.value =
          variantId;
      }

      if (buyNowButton) {
  buyNowButton.disabled = false;
}

    }
  );

});


/* ==========================================================
   ADD TO CART VALIDATION
   ========================================================== */

var productForm = root.querySelector(
  "#sticky-cart-form"
);

if (productForm) {

  productForm.addEventListener(
    "submit",
    function (event) {

      if (
        !stickyVariantInput ||
        !stickyVariantInput.value
      ) {

        event.preventDefault();

        showSizeMessage(
          "Please select a size before adding to cart."
        );

        return false;
      }

    }
  );

}


/* ==========================================================
   BUY NOW
   ========================================================== */

var buyNowForm = root.querySelector(
  "#buy-now-form-" + root.dataset.sectionId
);

if (buyNowButton && buyNowForm) {

  buyNowButton.addEventListener("click", function (event) {

    if (
      !buyNowVariantInput ||
      !buyNowVariantInput.value
    ) {
      event.preventDefault();

      showSizeMessage(
        "Please select a size before continuing."
      );

      return;
    }

    /* Size selected — allow normal form submission */
  });

}


/* ==========================================================
   STICKY ADD TO CART VALIDATION
   ========================================================== */

var stickyForm = root.querySelector(
  "#sticky-cart-form"
);

if (stickyForm) {

  stickyForm.addEventListener(
    "submit",
    function (event) {

      if (
        !stickyVariantInput ||
        !stickyVariantInput.value
      ) {

        event.preventDefault();

        showSizeMessage(
          "Please select a size before adding to cart."
        );

        return false;
      }

    }
  );

}


    /* ==========================================================
       CLEANUP
       ========================================================== */

    return function destroy() {

      window.removeEventListener(
        "scroll",
        handleStickyBar
      );

      if (observer) {
        observer.disconnect();
      }

      clearTimeout(galleryScrollTimer);
    };
  }


  /* ==========================================================
     INITIALISE
     ========================================================== */

  function boot() {
    var root = document.getElementById(
      "elore-product-section"
    );

    if (!root) return;

    if (
      typeof root._eloreProductDestroy ===
      "function"
    ) {
      root._eloreProductDestroy();
    }

    root.dataset.sectionId =
      root.dataset.sectionId || "";

    root._eloreProductDestroy =
      initProductPage(root);
  }


  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      boot
    );
  } else {
    boot();
  }


  /* ==========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================== */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      var section = event.target;

      if (
        section &&
        section.querySelector &&
        section.querySelector(
          "#elore-product-section"
        )
      ) {
        boot();
      }

    }
  );


  document.addEventListener(
    "shopify:section:unload",
    function (event) {

      var section = event.target;

      if (
        section &&
        section.querySelector
      ) {

        var root =
          section.querySelector(
            "#elore-product-section"
          );

        if (
          root &&
          typeof root._eloreProductDestroy ===
          "function"
        ) {
          root._eloreProductDestroy();
          root._eloreProductDestroy = null;
        }

      }

    }
  );

})();